export default __webpack_public_path__ + "static/media/thegallery.c6412acf.png";